export default {

  READ_FUNDED_ACCOUNTS: "/funded-account/read/request",
  READ_FUNDED_ACCOUNTS_SUCCESS: "/funded-account/read/success",
  READ_FUNDED_ACCOUNTS_ERROR: "/funded-account/read/error",
  
};